// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-grids-tabular-grid-for-key-element-display-module__pageContainer--Veap4 {
  display: flex;
  flex-direction: column;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__row--D8JvJ {
  display: flex;
  width: 100%;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__rowGap--i8cB5 {
  margin-bottom: 5px;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__rowCell--wQS8J {
  display: flex;
  flex: 0 0 50%;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__rowCellGap--b15fn {
  margin-right: 20px;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__cellKey--RTymD {
  display: flex;
  flex: 0.2;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__cellValue--IA4Ct {
  display: flex;
  flex: 0.8;
}

.src-js-components-grids-tabular-grid-for-key-element-display-module__label--fPRK4 {
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/grids/tabular-grid-for-key-element-display.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".pageContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.row {\n  display: flex;\n  width: 100%;\n}\n\n.rowGap {\n  margin-bottom: 5px;\n}\n\n.rowCell {\n  display: flex;\n  flex: 0 0 50%;\n}\n\n.rowCellGap {\n  margin-right: 20px;\n}\n\n.cellKey {\n  display: flex;\n  flex: 0.2;\n}\n\n.cellValue {\n  display: flex;\n  flex: 0.8;\n}\n\n.label {\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `src-js-components-grids-tabular-grid-for-key-element-display-module__pageContainer--Veap4`,
	"row": `src-js-components-grids-tabular-grid-for-key-element-display-module__row--D8JvJ`,
	"rowGap": `src-js-components-grids-tabular-grid-for-key-element-display-module__rowGap--i8cB5`,
	"rowCell": `src-js-components-grids-tabular-grid-for-key-element-display-module__rowCell--wQS8J`,
	"rowCellGap": `src-js-components-grids-tabular-grid-for-key-element-display-module__rowCellGap--b15fn`,
	"cellKey": `src-js-components-grids-tabular-grid-for-key-element-display-module__cellKey--RTymD`,
	"cellValue": `src-js-components-grids-tabular-grid-for-key-element-display-module__cellValue--IA4Ct`,
	"label": `src-js-components-grids-tabular-grid-for-key-element-display-module__label--fPRK4`
};
export default ___CSS_LOADER_EXPORT___;
